import { ref } from "vue";
import { useStore } from "@/store";
const store = useStore();
const activeRowModal: any = ref({ data: null });
import { GeneralActionTypes } from "@/store/modules/general/action-types";
import i18n from '@/localization/i18n';
const { t } = i18n.global;

function getFolderNameById(value: number): string | undefined {
    const folderMaps = store.state.general.folderMaps as { label: string; value: number }[];
    const folder = folderMaps.find((item: any) => item.value === value);
    return folder?.label;
}
function getSecurityActionStyle(label: string) {
    let color = '#3BCA0A';
    let bg = '#3FB91533';

    if (label.includes('Allow to run off')) {
        color = '#E04C4D';
        bg = '#DE323229';
    } else {
        color = '#3BCA0A';
        bg = '#3FB91533';
    }

    return { color, bg };
}
const data = {
    filter: {
        title: "codeLoadfilter",
        pageName: "codeLoadfilter",
        genre: "codeLoadPageFilter",
        ignoreSaveFilter: true,
        noDateSelect: true,
        hideFilter: false,
        //quickSearch: "fullTextSearch",
        filters: [
        ],
    },
    header: {
        navigation: [

        ],
        buttonPosition: "pr-4 justify-content-between",
        buttons: [

        ],
    },
    component: {
        type: "ag-table",
        options: {
            columns: [
                {
                    label: "",
                    field: "id",
                    isKey: true,
                    hidden: () => true,
                    width: "1%",
                },
                {
                    label: () => t('path').toUpperCase(),
                    field: "fileName",
                    sortable: true,
                    jsSort: true,
                    display: (row: any) => {
                        const truncateMiddle = (input: string, max = 50): string => {
                            const str = (input || "").toString();
                            if (str.length <= max) return str;
                            return str.slice(0, max) + "...";
                        };
                        const path = row.fileName ?? "";
                        const hasFolderMap = row.folderMapId !== null && row.folderMapId !== undefined;
                        const folderMap = hasFolderMap ? (getFolderNameById(row.folderMapId) ?? "") : "";
                        const fullPath = !hasFolderMap && row.isFolderMapIdAny
                            ? `*\\${path}`
                            : (folderMap && path
                                ? `${folderMap}\\${path}`
                                : `${folderMap}${path}`);
                        let html = "<div class='d-flex flex-column align-items-start'>";
                        const lastSegment = (path || '').split('\\').pop() || '';
                        const lowerSeg = lastSegment.toLowerCase();
                        const hasExtension = /\.[a-z0-9]{1,8}$/.test(lowerSeg);
                        let iconClass = 'ag-icon_noun_folder';
                        if (hasExtension) {
                            if (lowerSeg.endsWith('.exe')) {
                                iconClass = 'ag-icon_exe';
                            } else {
                                iconClass = 'ag-icon_noun_file';
                            }
                        }
                        const leadingIcon = `<i class='ag-icon ${iconClass}' style='width:16px;height:19px;margin-right:8px;'></i>`;
                        const truncatedFullPath = truncateMiddle(fullPath, 50);
                        html += `<div class='d-flex align-items-center'>${leadingIcon}<span style='color: #01172F; font-weight: bold; ' >` + truncatedFullPath + "</span></div>"
                        if (row.enabled === false) {
                            html += "<div class='d-flex align-items-center' style='margin-top:10px; margin-left:24px'><i class='ag-icon ag-icon_warning_filled' style='font-size:0.8em !important;'></i><span style='font-size:0.7em; color:#636363'>This rule is disabled and will not be published</span></div>";
                        }
                        html += "</div>";
                        return html;
                    },
                    width: "50%",
                },
                {
                    label: () => t('securityAction').toUpperCase(),
                    field: "securityAction",
                    sortable: true,
                    jsSort: true,
                    display: (row: any) => {
                        let securityActions = "";
                        if (row.allowToRun) {
                            securityActions = "Allow to run";
                        } else {
                            securityActions = "Allow to run off";
                        }
                        const styles = row.allowToRun != null ? getSecurityActionStyle(securityActions) : { color: '#1677FF', bg: '#1677FF33' };
                        return `
                            <span style='margin-left:8px;background:${styles.bg};color:${styles.color};border-radius:16px;padding:2px 8px;font-weight:700;font-size:12px;display:inline-flex;align-items:center;'>
                                ${securityActions}
                            </span>`;
                    },
                    width: "30%",
                },
                {
                    label: () => t('action').toUpperCase(),
                    field: "commands",
                    justify: 'justify-content-center',
                    style: { justifyItems: 'center' },
                    components: [
                        {
                            component: "appGroupTableEditComponent",
                        },
                        {
                            component: "copyAction",
                            class: "mr-2 ml-2",
                        },
                        {
                            component: "appGroupDeleteComponent",
                        },
                    ],
                    width: "120px",
                },
            ],
            rows: [],
            total: 0,
            sortable: {
                order: "",
                sort: "asc",
            },
            page: 0,
            pageSize: 0,
            showPagination: false,
            isLoading: true,
            dateFilter: false,
            zebra: true,
            separateBorders: true,
            editOnRowClick: true,
            hasCheckbox: ((): boolean => {
                try {
                    if (typeof window === 'undefined') return true;
                    const path = window.location?.pathname || '';
                    const isTemplateList = path.includes('/administration/app-group-management/detail-role');
                    const templateStr = localStorage.getItem("agms_template");
                    let isTemplate = false;
                    if (templateStr) {
                        try {
                            const template = JSON.parse(templateStr);
                            isTemplate = template && typeof template === 'object' && Object.keys(template).length > 0;
                        } catch {
                            isTemplate = false;
                        }
                    }

                    if (isTemplateList || isTemplate) {
                        return false;
                    }
                    return true;
                } catch {
                    return true;
                }
            })(),
            fetchTable: (options: any) => {
                store.dispatch(GeneralActionTypes.GET_APPGROUP_CODE_LOAD, {
                    options: options,
                    filters: {}
                });
            }
        },
    },

};

export default data;
